import React from 'react';
import { Form, Input } from 'antd';

// Supplier identity + primary contact fields (wizard step 1 / top of the Add Supplier modal).
const SupplierContactFields: React.FC = () => (
	<>
		<Form.Item
			label="Supplier Company Name"
			name="companyName"
			rules={[{ required: true, message: 'Company name is required.' }]}
		>
			<Input placeholder="John's Plumbing Service" />
		</Form.Item>
		<Form.Item
			label="Supplier Contact Email Address"
			name="contactEmail"
			rules={[
				{ required: true, message: 'Contact email is required.' },
				{ type: 'email', message: 'Please enter a valid email.' },
			]}
		>
			<Input placeholder="John.Doe@doeplumbing.com" />
		</Form.Item>
		<div className="flex flex-row" style={{ gap: '16px' }}>
			<Form.Item
				className="flex-1"
				label="Contact First Name"
				name="contactFirstName"
				rules={[{ required: true, message: 'First name is required.' }]}
			>
				<Input placeholder="John" />
			</Form.Item>
			<Form.Item
				className="flex-1"
				label="Contact Last Name"
				name="contactLastName"
				rules={[{ required: true, message: 'Last name is required.' }]}
			>
				<Input placeholder="Doe" />
			</Form.Item>
		</div>
	</>
);

export default SupplierContactFields;
